/**
 * Generated from hh_ch2_72dpi_p05-06-07.fla
 */
export function hh_ch2_72dpi_p050607(this: Ihh_ch2_72dpi_p050607) {
	const bg = this.bg;
	if (!bg[0] && bg.elementFactory) {
		bg[0] = bg.elementFactory(0,undefined);
	}
	if (bg[0]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bgamy.call(bg[0] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bgamy);
		bg[0].x = 832;
		bg[0].y = 384;
		bg[0].width = 1664.00;
		bg[0].height = 768.00;
		bg[0].alpha = 1;
		if (bg[0].onLayout) bg[0].onLayout();
	}
	if (!bg[1] && bg.elementFactory) {
		bg[1] = bg.elementFactory(1,undefined);
	}
	if (bg[1]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bgpiper.call(bg[1] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bgpiper);
		bg[1].x = 832;
		bg[1].y = 384;
		bg[1].width = 1664.00;
		bg[1].height = 768.00;
		bg[1].alpha = 1;
		if (bg[1].onLayout) bg[1].onLayout();
	}
	if (!bg[2] && bg.elementFactory) {
		bg[2] = bg.elementFactory(2,undefined);
	}
	if (bg[2]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bgoscar.call(bg[2] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bgoscar);
		bg[2].x = 832;
		bg[2].y = 384;
		bg[2].width = 1664.00;
		bg[2].height = 768.00;
		bg[2].alpha = 1;
		if (bg[2].onLayout) bg[2].onLayout();
	}
	const bubbleReveal = this.bubbleReveal;
	if (!bubbleReveal[0] && bubbleReveal.elementFactory) {
		bubbleReveal[0] = bubbleReveal.elementFactory(0,undefined);
	}
	if (bubbleReveal[0]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblereveal.call(bubbleReveal[0] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblereveal);
		bubbleReveal[0].x = 832;
		bubbleReveal[0].y = 261.75;
		bubbleReveal[0].width = 916.50;
		bubbleReveal[0].height = 482.50;
		bubbleReveal[0].alpha = 1;
		if (bubbleReveal[0].onLayout) bubbleReveal[0].onLayout();
	}
	if (!bubbleReveal[1] && bubbleReveal.elementFactory) {
		bubbleReveal[1] = bubbleReveal.elementFactory(1,undefined);
	}
	if (bubbleReveal[1]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblereveal.call(bubbleReveal[1] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblereveal);
		bubbleReveal[1].x = 832;
		bubbleReveal[1].y = 261.75;
		bubbleReveal[1].width = 916.50;
		bubbleReveal[1].height = 482.50;
		bubbleReveal[1].alpha = 1;
		if (bubbleReveal[1].onLayout) bubbleReveal[1].onLayout();
	}
	if (!bubbleReveal[2] && bubbleReveal.elementFactory) {
		bubbleReveal[2] = bubbleReveal.elementFactory(2,undefined);
	}
	if (bubbleReveal[2]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblereveal.call(bubbleReveal[2] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblereveal);
		bubbleReveal[2].x = 832;
		bubbleReveal[2].y = 261.75;
		bubbleReveal[2].width = 916.50;
		bubbleReveal[2].height = 482.50;
		bubbleReveal[2].alpha = 1;
		if (bubbleReveal[2].onLayout) bubbleReveal[2].onLayout();
	}
	const bubbleStart = this.bubbleStart;
	if (!bubbleStart[0] && bubbleStart.elementFactory) {
		bubbleStart[0] = bubbleStart.elementFactory(0,undefined);
	}
	if (bubbleStart[0]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblestart.call(bubbleStart[0] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblestart);
		bubbleStart[0].x = 832;
		bubbleStart[0].y = 261.75;
		bubbleStart[0].width = 916.50;
		bubbleStart[0].height = 482.50;
		bubbleStart[0].alpha = 1;
		if (bubbleStart[0].onLayout) bubbleStart[0].onLayout();
	}
	if (!bubbleStart[1] && bubbleStart.elementFactory) {
		bubbleStart[1] = bubbleStart.elementFactory(1,undefined);
	}
	if (bubbleStart[1]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblestart.call(bubbleStart[1] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblestart);
		bubbleStart[1].x = 832;
		bubbleStart[1].y = 261.75;
		bubbleStart[1].width = 916.50;
		bubbleStart[1].height = 482.50;
		bubbleStart[1].alpha = 1;
		if (bubbleStart[1].onLayout) bubbleStart[1].onLayout();
	}
	if (!bubbleStart[2] && bubbleStart.elementFactory) {
		bubbleStart[2] = bubbleStart.elementFactory(2,undefined);
	}
	if (bubbleStart[2]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblestart.call(bubbleStart[2] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblestart);
		bubbleStart[2].x = 832;
		bubbleStart[2].y = 261.75;
		bubbleStart[2].width = 916.50;
		bubbleStart[2].height = 482.50;
		bubbleStart[2].alpha = 1;
		if (bubbleStart[2].onLayout) bubbleStart[2].onLayout();
	}
	const chair = this.chair;
	if (!chair[0] && chair.elementFactory) {
		chair[0] = chair.elementFactory(0,undefined);
	}
	if (chair[0]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_chair.call(chair[0] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_chair);
		chair[0].x = 805;
		chair[0].y = 768;
		chair[0].width = 266.00;
		chair[0].height = 160.50;
		chair[0].alpha = 1;
		if (chair[0].onLayout) chair[0].onLayout();
	}
	if (!chair[1] && chair.elementFactory) {
		chair[1] = chair.elementFactory(1,undefined);
	}
	if (chair[1]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_chair.call(chair[1] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_chair);
		chair[1].x = 805;
		chair[1].y = 768;
		chair[1].width = 266.00;
		chair[1].height = 160.00;
		chair[1].alpha = 1;
		if (chair[1].onLayout) chair[1].onLayout();
	}
	if (!chair[2] && chair.elementFactory) {
		chair[2] = chair.elementFactory(2,undefined);
	}
	if (chair[2]) {
		hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_chair.call(chair[2] as Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_chair);
		chair[2].x = 805;
		chair[2].y = 768;
		chair[2].width = 266.00;
		chair[2].height = 160.00;
		chair[2].alpha = 1;
		if (chair[2].onLayout) chair[2].onLayout();
	}
	const amy = this.amy;
	hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5AmyFPOTHISWILLBESPINEANIM.call(this.amy);
	amy.x = 906.25;
	amy.y = 768;
	amy.width = 488.50;
	amy.height = 431.50;
	amy.alpha = 1.00;
	if (amy.onLayout) amy.onLayout();
	const piper = this.piper;
	hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6PiperFPOTHISWILLBESPINEANIM.call(this.piper);
	piper.x = 799.5;
	piper.y = 768;
	piper.width = 280.00;
	piper.height = 449.00;
	piper.alpha = 1.00;
	if (piper.onLayout) piper.onLayout();
	const oscar = this.oscar;
	hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7OscarFPOTHISWILLBESPINEANIM.call(this.oscar);
	oscar.x = 812.25;
	oscar.y = 768;
	oscar.width = 669.50;
	oscar.height = 468.50;
	oscar.alpha = 1.00;
	if (oscar.onLayout) oscar.onLayout();
	const frameLeft = this.frameLeft;
	hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 283.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const frameRight = this.frameRight;
	hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLayer162.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 295.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bgamy(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bgamy) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p05_bgamy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblereveal(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblereveal) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p05_bubblereveal", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblestart(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblestart) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p05_bubblestart", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_chair(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_chair) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p05_chair", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5AmyFPOTHISWILLBESPINEANIM(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5AmyFPOTHISWILLBESPINEANIM) {
	if (this.setLayoutTexture) this.setLayoutTexture("AmyFPOTHISWILLBESPINEANIM", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bgpiper(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bgpiper) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p06_bgpiper", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblereveal(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblereveal) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p06_bubblereveal", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblestart(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblestart) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p06_bubblestart", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_chair(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_chair) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p06_chair", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6PiperFPOTHISWILLBESPINEANIM(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6PiperFPOTHISWILLBESPINEANIM) {
	if (this.setLayoutTexture) this.setLayoutTexture("PiperFPOTHISWILLBESPINEANIM", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bgoscar(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bgoscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p07_bgoscar", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_chair(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_chair) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p07_chair", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblereveal(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblereveal) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p07_bubblereveal", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblestart(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblestart) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p07_bubblestart", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7OscarFPOTHISWILLBESPINEANIM(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7OscarFPOTHISWILLBESPINEANIM) {
	if (this.setLayoutTexture) this.setLayoutTexture("OscarFPOTHISWILLBESPINEANIM", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLframe(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function hh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLayer162(this: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLayer162) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer162", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ihh_ch2_72dpi_p050607Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ihh_ch2_72dpi_p050607Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ihh_ch2_72dpi_p050607Sprite extends Ihh_ch2_72dpi_p050607Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ihh_ch2_72dpi_p050607Text extends Ihh_ch2_72dpi_p050607Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ihh_ch2_72dpi_p050607Polygon extends Array<number> {
}
interface Ihh_ch2_72dpi_p050607 {
	readonly bg: Ihh_ch2_72dpi_p050607Array<Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bgamy|Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bgpiper|Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bgoscar>;
	readonly bubbleReveal: Ihh_ch2_72dpi_p050607Array<Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblereveal|Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblereveal|Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblereveal>;
	readonly bubbleStart: Ihh_ch2_72dpi_p050607Array<Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblestart|Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblestart|Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblestart>;
	readonly chair: Ihh_ch2_72dpi_p050607Array<Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_chair|Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_chair|Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_chair>;
	readonly amy: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5AmyFPOTHISWILLBESPINEANIM;
	readonly piper: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6PiperFPOTHISWILLBESPINEANIM;
	readonly oscar: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7OscarFPOTHISWILLBESPINEANIM;
	readonly frameLeft: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLframe;
	readonly frameRight: Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLayer162;
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bgamy extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblereveal extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_bubblestart extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_chair extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5AmyFPOTHISWILLBESPINEANIM extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bgpiper extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblereveal extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_bubblestart extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6chp2_p06_chair extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset6PiperFPOTHISWILLBESPINEANIM extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bgoscar extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_chair extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblereveal extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7chp2_p07_bubblestart extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset7OscarFPOTHISWILLBESPINEANIM extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLframe extends Ihh_ch2_72dpi_p050607Sprite {
}
interface Ihh_ch2_72dpi_p050607_hh_ch2_72dpi_p050607psdAsset5chp2_p05_wcframeLayer162 extends Ihh_ch2_72dpi_p050607Sprite {
}
